import React, { createContext, useReducer, useContext } from "react";
import { ToastNotificationReducer } from "../reducers/ToastNotificationReducer";
import {
  TOAST_NOTIFICATION_ACTIONS,
  TOAST_NOTIFICATION_LEVELS,
} from "../../constants/Constants";

export const ToastNotificationContext = createContext();

export const useToastNotification = () => {
  const context = useContext(ToastNotificationContext);
  const { dispatch } = context;
  const sendToastMessage = (
    messageId = null,
    defaultMessage = null,
    lvl = TOAST_NOTIFICATION_LEVELS.SUCCESS,
  ) => {
    const toastId = `toast-${Date.now()}`;
    dispatch({
      type: TOAST_NOTIFICATION_ACTIONS.SHOW_SINGLE_TOAST,
      payload: {
        id: toastId,
        messageId: messageId,
        defaultMessage: defaultMessage,
        level: lvl,
        timeout: 3000,
      },
    });
  };

  return { sendToastMessage };
};

const ToastNotificationContextProvider = (props) => {
  const initialState = {
    toasts: [],
  };

  const [toastState, dispatch] = useReducer(
    ToastNotificationReducer,
    initialState,
  );

  return (
    <ToastNotificationContext.Provider value={{ toastState, dispatch }}>
      {props.children}
    </ToastNotificationContext.Provider>
  );
};

export default ToastNotificationContextProvider;



// WEBPACK FOOTER //
// ./src/components/mySCC/common/context/ToastNotificationContext.js